<!--第三方应用-->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea ThirdApplication">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <BreadCrumb></BreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">

        <!-- 添加第三方应用列表 -->
        <div class="addButton">
          <el-button type="primary" @click="operateUserInfo('add')">添加</el-button>
        </div>

        <!-- 第三方应用列表 -->
        <el-table
          v-loading="loading"
          :data="thirdAppList"
          style="width: 100%">
          <el-table-column
            type="index"
            label="序号">
          </el-table-column>
          <el-table-column
            prop="name"
            label="应用名称"
            width="250">
          </el-table-column>
          <el-table-column
            prop="nickname"
            label="代号"
            width="80">
          </el-table-column>
          <el-table-column
            label="访问地址">
            <template slot-scope="scope">
              <a :href="scope.row.url" target="_blank">{{scope.row.url}}</a>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="状态"
            width="60">
            <template slot-scope="scope">
              <el-button @click="operateUserInfo('changeStatus', scope.row)" type="text">{{scope.row.status === '1' ? '上架' : '下架'}}</el-button>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="operateUserInfo('alter', scope.row)">修改</el-button>
              <el-button type="text" @click="operateUserInfo('delete', scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="paging" v-if="paging.pageCount > 1">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="paging.page"
            layout="prev, pager, next, jumper"
            :page-count="paging.pageCount">
          </el-pagination>
        </div>

        <!--对话框-->
        <el-dialog
          :title="dialogData.title" 
          :visible.sync="dialogData.visible"
          :show-close="dialogData.title === '' ? false : true">
          
          <!-- 状态 -->
          <div
            class="changeStatusWrapper"
            v-if="dialogData.type === 'changeStatus'">
            <p class="text">
              当前第三方应用状态为
              <span class="bold">
                {{dialogData.info.status === '1' ? '上架' : '下架' }}
              </span>
            </p>
            <p class="text">
              是否将状态改为
              <span class="bold">
                {{dialogData.info.status === '1' ? '下架' : '上架'}}？
              </span>
            </p>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">取 消</el-button>
              <el-button @click="changeThirdApp(dialogData.info.status === '1' ? 'off' : 'on')">{{dialogData.info.status === '1' ? '下架' : '上架'}}</el-button>
            </div>
          </div>

          <!-- 删除第三方应用 -->
          <div
            class="changeStatusWrapper"
            v-else-if="dialogData.type === 'delete'">
            <p
              class="text">
              是否删除名称为<span class="bold"> {{dialogData.info.name}} </span>的应用吗？
            </p>

            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogData.visible = false">否</el-button>
              <el-button @click="changeThirdApp('del')">是</el-button>
            </div>
          </div>

          <!-- 添加或修改第三方应用信息 -->
          <div v-else>
            <el-form
              label-width="80px"
              :model="dialogData.info">
              <el-form-item label="应用名称:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.name"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="代号:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.nickname"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="访问地址:">
                <div class="inputBox">
                  <el-input class="inputDeposit" v-model="dialogData.info.url"></el-input>
                </div>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="updateThirdApp()">确 认</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../Layout/BreadCrumb.vue"
  import { showToast, deepCopy } from "../../../../static/js/utility/utility.js"
  import { systemApi } from "../../../../static/js/api.js"

  export default {
    name: 'ThirdApplication',
    components: {
      BreadCrumb
    },
    data() {
      return {
        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          info: {}
        },
        // 分页数据  page为当前页，perPage为每页数量 
        paging: {
          page: 1,
          perPage: 10,
          pageCount: ''
        },
        // 第三方应用列表
        thirdAppList:[],
        loading: false
      }
    },
    mounted(){
      this.getThirdAppList()
    },
    created: function () {
    },
    methods: {
      // 当前页值改变，获取新的第三方应用列表
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`);
        this.getThirdAppList()
      },
      // 获取第三方应用列表
      getThirdAppList: async function () {
        let vm = this
        let data = {
          page: this.paging.page,
          perPage: this.paging.perPage
        }

        vm.loading = true
        let res = await systemApi.getThirdAppList(data)
        vm.loading = false
        if (res.meta.code === 200) {
          // console.log('第三方应用列表', res.data.list)
          this.thirdAppList = res.data.list
          this.paging.pageCount = res.data.pageCount
        } else {
          showToast(res.meta.message)
        }
      },
      // 操作客户信息（添加或修改）dialogData
      operateUserInfo: function (type, info) {
        let infoNull = {
            company_name: '' ,
            phone_no: '',
            email: ''
          }
        this.dialogData = {
          type: type,
          title: type === 'changeStatus' ? '' : type === 'add' ? '添加客户信息' : type === 'alter' ? '修改客户信息' : '重置密码',
          visible: !(this.dialogData.visible),
          info: info ? deepCopy(info) : infoNull
        }
        console.log('this', this.dialogData)
      },
      // 改变第三方应用 action(on上架 off下架 del删除) 
      changeThirdApp: async function (action) {
        let vm = this
        let data = {
          id: vm.dialogData.info.id,
          action: action
        }
        console.log('data', data)
        let res = await systemApi.changeThirdApp(data)
        if (res.meta.code === 200) {
          showToast(action === 'del' ? '删除成功' : '修改成功')
          vm.dialogData.visible = !(this.dialogData.visible)
          vm.getThirdAppList()
        } else {
          showToast(res.meta.message)
        }
      },
      // 更新（添加/修改）第三方应用信息
      updateThirdApp: async function () {
        let vm = this
        let data = {
          id: vm.dialogData.info.id ? vm.dialogData.info.id : '',
          name: vm.dialogData.info.name,
          url: vm.dialogData.info.url,
          nickname: vm.dialogData.info.nickname
        }
        console.log('data', data)
        let res = await systemApi.updateThirdApp(data)
        if (res.meta.code === 200) {
          showToast(data.id === '' ? '添加成功' : '修改成功')
          vm.dialogData.visible = !(this.dialogData.visible)
          vm.getThirdAppList()
        } else {
          showToast(res.meta.message)
        }
      }
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss" scoped>
.addButton {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Page/System/ThirdApplication.vue